import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export const keys = {
    all: ["access-control"],
    accessFunctionalityDatas: () => [
        ...keys.all,
        "accessFunctionalityData"
    ],
    accessFunctionalityData: (groupID: number) => [
        ...keys.accessFunctionalityDatas(),
        {
            groupID
        }
    ],

    objectUserRoleAccessToObjectsLists: () => [
        ...keys.all,
        "objectUserRoleAccessToObjectsList"
    ],

    objectUserRoleAccessToObjectsList: (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number
    ) => [
        ...keys.objectUserRoleAccessLists(),
        {
            groupID,
            objectType,
            objectID
        }
    ],

    objectUserRoleAccessLists: () => [
        ...keys.all,
        "objectUserRoleAccessLists"
    ],

    objectUserRoleAccessList: (
        groupID: number,
        objectType: eLynxObjectTypeEnum
    ) => [
        ...keys.objectUserRoleAccessLists(),
        {
            groupID,
            objectType
        }
    ],

    availableObjects: (
        groupID: number,
        objectType: eLynxObjectTypeEnum
    ) => [
        ...keys.all,
        "availableObjects", {
            groupID,
            objectType
        }
    ]
};
